import React from 'react';

import {AreColorsClose, hexToRgbA} from './../UniversalMethods' 

import './PalletteThumbnail.css';

const PalletteThumbnail = (props) => {

    const colorsCount = props.colors.length;

    // Change width for close one
    // To do that find how many colors are close
    const closeColorCount = typeof props.highlightColor !== 'undefined' ? props.colors.filter(color => AreColorsClose(color, props.highlightColor)).length : 0;
    const highlightWidth = 100/colorsCount * 1.5;


    const textRgbObj=hexToRgbA(props.textColor);

    return <div className='pallette-thumbnail'>
        {props.colors.map((color, index) => {
            const rgbObj=hexToRgbA(color);
            // check if highlight
            const isHighlight = closeColorCount === 0 ? undefined : AreColorsClose(color, props.highlightColor);

            // set each color
            const width = closeColorCount === 0 ? 100/colorsCount :
                isHighlight ? 
                    highlightWidth :
                    (100-highlightWidth*closeColorCount)/(colorsCount-closeColorCount);

            return <div key={`pallette-color-${color}`} className={`color ${isHighlight ? 'highlight' : ''} ${props.transition === color ? 'transition' : ''}`} style={{width: width + '%'}}>
                <div className='background-color-container' onMouseDown={() => props.colorCallback(color)}>
                    <div className='background-color' style={{backgroundColor: '#' + color, borderColor: 'rgba('+textRgbObj.r+','+textRgbObj.g+','+textRgbObj.b+',0)'}}/>
                </div>
                <div className='color-value hex-value' style={{color: '#' + props.textColor}}>{`#${color}`}</div>
                <div className='color-value rgb-value' style={{color: '#' + props.textColor}}>{`${rgbObj.r}, ${rgbObj.g}, ${rgbObj.b}`}</div>
            </div>
        })}
    </div>
}

export default PalletteThumbnail;